import { render, staticRenderFns } from "./PremiumOffers-fr.vue?vue&type=template&id=77a420ee&"
import script from "./PremiumOffers-fr.vue?vue&type=script&lang=js&"
export * from "./PremiumOffers-fr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports